module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticStyle: {
      "page-break-before": "always",
      "text-align": "center",
      "text-decoration": "underline",
      "text-indent": "0"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "font-size": "small"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-p"
  }, [_vm._v("P")]), _vm._v("ARKER JAMES KILLED")]), _vm._v(" his father, one of the founders and kingpins in the Inner Circle.")]), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Now his son, groomed to replace the father in the Inner Circle, and trained to be an assassin will seek revenge.")]), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("He is known as the Scarecrow. ")]), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Perfect for Parker James. Having the Scarecrow after him will get him closer to Oz. ")]), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("But now the other players, including Dorothy, The Wizard, and the Lion's coming out to play, too.")]), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("**The Inner Circle Series is a Dark College Romance Thriller with lots of action, steamy scenes, language, and twists and turns. Recommended for age 18 and up.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-decoration": "underline",
      "text-indent": "0"
    }
  }, [_vm._v("ABOUT KAILIN GOW")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-f"
  }, [_vm._v("F")]), _vm._v("ROM VISITING ROMANIA")]), _vm._v(", ALA YALSA Award-winning and Million-Selling Author Kailin Gow was asked to write stories about vampires; visiting the Black Forest in Germany and seeing the castles of Europe inspired her to write fantasy; visiting Asia's mystical mountains inspired her to write action adventure and mythological dystopians. From her experience in college as a peer counselor and her volunteer work with women's shelters, she was inspired to write contemporary romance with social issues for women, new adults, young adults, and teens. Having faced adversity, including battling stereotypes, Kailin Gow has become a well-known speaker and influential figure in media. She has traveled around the world, where she has ridden on top of elephants through jungles, hand-fed sting rays, studied kung fu from a Shaolin Temple monk, and learned cooking from a celebrity chef. She is a USA Today Bestselling author and has been a #1 Amazon bestselling author over two-hundred times. Her Bitter Frost Series is in development as a TV Series, and her contemporary romance Loving Summer is set to become a feature film. Two of her book series – The Red Genesis Series and The FADE Series, has been optioned by Netflix. An multi-award-winning filmmaker, director, and actress; Kailin’s films have premiered at Cannes, Los Angeles, Rome, England, Paris, Korea, Japan, and even in India’s Ministry of Culture.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Compelled to write her first fiction book because of 9/11, Kailin Gow now has over 675 fiction books published under Kailin Gow and various Pen Names in many genres.  As a speaker and host, she has hosted international shows at the Pasadena Civic Auditorium, been a celebrity judge at beauty pageants, been a judge for writing contests, and hosted television series.  She was featured as an Indie Author Success Story on the homepage of Amazon.com for a month and is also included in Amazon’s book called Transformations. She is the first Asian American to have been featured on Amazon’s homepage as an Author Success Story, and the first to have sold over a million books. ")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene"
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-k"
  }, [_vm._v("K")]), _vm._v("EEP UP-TO-DATE WITH")]), _vm._v(" Kailin at:")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-decoration": "underline"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://madmimi.com/signups/5e9ebf668aa14b4890d8affb0ce952f9/join",
      "target": "_blank"
    }
  }, [_vm._v("madmimi.com/signups/5e9ebf668aa14b4890d8affb0ce952f9/join")])]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene"
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-f"
  }, [_vm._v("F")]), _vm._v("ACEBOOK")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-decoration": "underline"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://www.facebook.com/OfficialKailinGow",
      "target": "_blank"
    }
  }, [_vm._v("facebook.com/OfficialKailinGow")])]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-b"
  }, [_vm._v("B")]), _vm._v("OOKBUB")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-decoration": "underline"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.bookbub.com/authors/kailin-gow",
      "target": "_blank"
    }
  }, [_vm._v("bookbub.com/authors/kailin-gow")])]), _vm._v(" "), _c('p', [_vm._v("Instagram")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-decoration": "underline"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/kailingow",
      "target": "_blank"
    }
  }, [_vm._v("instagram.com/kailingow")])]), _vm._v(" "), _c('p', [_vm._v("Sign Up for News on Master Classes and Author Career Courses Taught by Kailin at: ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-decoration": "underline"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://www.subscribepage.com/kailingowauthorcourses",
      "target": "_blank"
    }
  }, [_vm._v("subscribepage.com/kailingowauthorcourses")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "large",
      "page-break-before": "always",
      "text-align": "center",
      "text-decoration": "underline",
      "text-indent": "0"
    }
  }, [_vm._v("SERIES BY KAILIN GOW")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "font-size": "small"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-y"
  }, [_vm._v("***Y")]), _vm._v("A FOR 16 AND UP**")]), _vm._v("*")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("The Frost Series – In Development as a TV Series!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("The Wolf Fey Series")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("The PULSE Series")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("FADE Series – Optioned by Netflix!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("DESIRE Series")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Fire Wars Series")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Alchemists Academy")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Wordwick Games")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Wicked Woods Series")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Steampunk Scarlett")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("The Phantom Diaries")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Stoker Sisters")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Beyond Crystal River ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Red Genesis Series – Optioned by Netflix!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("The Summer Pact ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small",
      "font-weight": "bold"
    }
  }, [_vm._v("***For 18 and up (New Adult/Coming of Age)***")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Hidden Falls High (Reverse Harem NA/YA)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Loving Summer  - Filming to become a Featured Film!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("The Donovan Brothers")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Saving You Saving Me (You & Me Trilogy)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Never Knights")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Rock Hard Musical ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Shadowlight Academy (Reverse Harem Paranormal Romance)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Shadowlight Hunters Academy (Reverse Harem Paranormal Romance)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Society of Supernatural Sleuths (Reverse Harem Paranormal Romance)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small",
      "font-weight": "bold"
    }
  }, [_vm._v("***For 18 and up (Adult/Steamy Romance)***")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("The Protege")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Master Chefs")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("The Blue Room (Spin-off of Never Knights Trilogy)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("The Blue Room Chronicles")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Sessions")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("HEAT ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("UNassumed Series")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Beautiful Girl (Standalone Novel)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("The Tutor (Standalone Novel)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Rock Hard")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("***For Middle Grade (STEM Books in School) ***")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Fairy Rose Chronicles - age 13 and up.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("Amazon Lee Adventures Series Co-written with  USA Today Bestselling Author Kira G.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Prologue")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26b8d63c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c003.vue
// module id = 66
// module chunks = 0